import { computed, defineComponent, watch, ref, onMounted, } from '@vue/composition-api';
import { OFFER_STATUS_COLORS } from '@/constants/offer';
import { genericTableRowSize } from '@/components/Table/__new__/_components/TableCellGeneric';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
import { useOfferColumns } from '@/views/Brand/Applications/Offer/_composables/use-offer-columns';
import { GenericAGTable } from '@/components/Table/AGTable/AGTable.vue';
import { getOfferList } from '@/api/v2/requests/offers';
import FloatingTextFilter from '@/components/Table/AGTable/_components/FloatingTextFilter.vue';
import OfferStatusCell from '@/views/Brand/Applications/Components/Offers/OfferStatusCell.vue';
import FloatingSelectFilter from '@/components/Table/AGTable/_components/FloatingSelectFilter.vue';
import TableFooter from '@/views/_components/Table/TableFooter.vue';
import { useTableQueryParams } from '@/components/Table/_composables/use-table-query-params';
export default defineComponent({
    components: {
        TableFooter,
        TableLoader,
        // eslint-disable-next-line vue/no-unused-components
        FloatingTextFilter,
        // eslint-disable-next-line vue/no-unused-components
        OfferStatusCell,
        // eslint-disable-next-line vue/no-unused-components
        FloatingSelectFilter,
        AgTable: GenericAGTable(),
    },
    setup(props, ctx) {
        const params = ctx.root.$route.params;
        const isLoading = ref(false);
        const rows = ref([]);
        const totalCount = ref(0);
        const brandId = params.id;
        const agTableRef = ref(null);
        const { page, perPage, query: tableQuery, handleFilterChange: handleQueryFilterChange, handleSort, resetSort, } = useTableQueryParams(ctx, {
            defaultPerPage: 25,
            filterParams: {
                internalNumber: 'internalNumber',
                title: 'title',
                status: 'status',
                centralCostName: 'centralCostName',
            },
            fieldMap: {
                'centralCost.name': 'centralCostName',
            },
            staticParams: {
                brandId,
            },
        });
        const query = computed(() => {
            return { ...tableQuery.value };
        });
        const handleRowClick = (offer) => {
            ctx.root.$router.push({
                name: 'OfferDetails',
                params: {
                    id: brandId,
                    offerId: offer.id,
                },
            });
        };
        const fetchItems = async () => {
            isLoading.value = true;
            try {
                const { nodes, totalCount: nodesCount } = await getOfferList(query.value ?? {});
                totalCount.value = nodesCount;
                rows.value = nodes;
            }
            catch (err) {
                console.error('Error fetching offers:', err);
                ctx.root.$toast.error(ctx.root.$t(`brand-offers.error-fetching`));
            }
            finally {
                isLoading.value = false;
            }
        };
        const changePage = (newPage) => {
            page.value = newPage;
        };
        const handleFilterChange = (filterModel) => {
            handleQueryFilterChange(filterModel);
        };
        const handleSortChange = (field, sort) => {
            handleSort(field, sort);
        };
        const handleResetSort = () => {
            resetSort();
        };
        const handlePerPageChange = (newPerPage) => {
            perPage.value = newPerPage;
            page.value = 1;
        };
        onMounted(async () => {
            await fetchItems();
        });
        const { columns } = useOfferColumns(ctx);
        watch(query, () => {
            fetchItems();
        }, { deep: true });
        return {
            columns,
            tableQuery,
            page,
            perPage,
            totalCount,
            genericTableRowSize,
            OFFER_STATUS_COLORS,
            rows,
            isLoading,
            handleRowClick,
            handleFilterChange,
            handleSortChange,
            handleResetSort,
            changePage,
            handlePerPageChange,
            agTableRef,
        };
    },
});
